import app from "flarum/forum/app";
import PlayerStatData from "../UserComponents/PlayerStatData";
import ItemList from "flarum/common/utils/ItemList";

export default class ZSData extends PlayerStatData {
  filter(key: string, data: any): boolean {
    return key == "id" ||
      key == "reborn" ||
      key == "online_time" ||
      key == "afk_time" ||
      key == "level" ||
      key == "sprays" ||
      (typeof data !== "number" && typeof data !== "bigint")
  }

  statName(key: string): string {
    return app.translator.trans(`rhodes-island.forum.zs_data.${key}`) as string;
  }

  levelItems(data: any): ItemList<any> {
    const items = super.levelItems(data);

    items.add("reborn", <div className="r-lvl">{data.reborn}</div>);

    return items;
  }
}
